import {
  START_TRACKING_PAGE_LOADER,
  STOP_TRACKING_PAGE_LOADER,
} from '../actions/uiActions';
import { GET_TRACKING_PAGE } from '../constants/loaderTypes';

const initialState = {
  loaders: {
    [GET_TRACKING_PAGE]: false,
  },
};

/* eslint-disable-next-line default-param-last */
function ui(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case START_TRACKING_PAGE_LOADER: {
      return {
        ...state,
        loaders: {
          [GET_TRACKING_PAGE]: true,
        },
      };
    }
    case STOP_TRACKING_PAGE_LOADER: {
      return {
        ...state,
        loaders: {
          [GET_TRACKING_PAGE]: false,
        },
      };
    }
    default: {
      return state;
    }
  }
}

export default ui;
